import { AddressInput } from "../../../clients/graphqlTypes.js";
import { AddressDetails__AddressFragment } from "./Addresses.generated.js";

export const getAddressInputFromAddress = (
  details: AddressDetails__AddressFragment
): AddressInput => {
  const address: AddressInput = {
    city: details.city,
    countryCode: details.countryCode,
    location: details.location
      ? {
          lat: details.location.lat,
          lng: details.location.lng,
        }
      : null,
    postalCode: details.postalCode,
    streetLines1: details.streetLines1,
  };

  return address;
};
